// extracted by mini-css-extract-plugin
export var border = "_5y-0";
export var borderSelected = "_5y-1";
export var check = "_5y-6";
export var circle = "_5y-2";
export var circleInner = "_5y-4";
export var circleInnerDisabled = "_5y-8";
export var description = "_5y-3";
export var horizontal = "_5y-b";
export var input = "_5y-5";
export var label = "_5y-9";
export var radioButton = "_5y-d";
export var radioButtonNoCenter = "_5y-e";
export var radioGroup = "_5y-a";
export var rightRadio = "_5y-f";
export var subcontent = "_5y-g";
export var uncheck = "_5y-7";
export var vertical = "_5y-c";